module.exports = __webpack_public_path__ + "static/media/12.081.dce04d4e.jpg";